"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
const images = [{
  id: 1,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/IMG_3606-scaled.jpg",
  alt: "Alpha Dental office photo 1"
}, {
  id: 2,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/IMG_3638-scaled.jpg",
  alt: "Alpha Dental office photo 2"
}, {
  id: 3,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/IMG_3617-scaled.jpg",
  alt: "Alpha Dental office photo 3"
}, {
  id: 4,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/IMG_3627-scaled.jpg",
  alt: "Alpha Dental office photo 4"
}, {
  id: 5,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/IMG_3627-scaled.jpg",
  alt: "Alpha Dental office photo 5"
}, {
  id: 6,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/Dr-Taylor.png",
  alt: "Dr. Taylor"
}, {
  id: 7,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/Dr-John.png",
  alt: "Dr. John"
}, {
  id: 8,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/Dr-Gaya.png",
  alt: "Dr. Gaya"
}, {
  id: 9,
  src: "https://ddsalpha.com/wp-content/uploads/2025/12/Banner-Alpha-scaled.jpg",
  alt: "Alpha Dental banner"
}];
export default function GalleryTour() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<{
    src: string;
    alt: string;
  } | null>(null);
  const openLightbox = (image: {
    src: string;
    alt: string;
  }) => {
    setSelectedImage(image);
    setLightboxOpen(true);
  };
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {images.map((image, i) => <Card key={image.id} data-index={i} className="group cursor-pointer overflow-hidden rounded-lg bg-background-card p-0 shadow-soft transition-all duration-[var(--duration-fast)] hover:-translate-y-0.5 hover:shadow-medium hover:ring-2 hover:ring-secondary" style={{
          animation: isVisible ? `fade-in-up var(--duration-medium) var(--ease-smooth) both ${i * 100}ms` : "none"
        }} onClick={() => openLightbox(image)}>
              <img src={image.src} alt={image.alt} loading="lazy" fetchpriority="high" className="h-64 w-full object-cover transition-transform duration-[var(--duration-fast)] group-hover:scale-105" />
            </Card>)}
        </div>
      </div>

      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent className="max-w-4xl p-0" showCloseButton={false}>
          <div className="relative">
            <DialogClose className="absolute right-4 top-4 z-10 rounded-lg bg-dark-background/80 p-2 text-foreground-dark opacity-90 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring">
              <X className="size-5" />
              <span className="sr-only">Close</span>
            </DialogClose>

            {selectedImage && <img src={selectedImage.src} alt={selectedImage.alt} className="h-auto w-full rounded-lg" />}
          </div>
        </DialogContent>
      </Dialog>

      <style>{`
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(1rem); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          @keyframes fade-in-up {
            from { opacity: 1; transform: none; }
            to { opacity: 1; transform: none; }
          }
        }
      `}</style>
    </section>;
}